import { spineBus } from '$src/lib/services/gatekeeper/MessageBus';
import { navigate } from '$src/lib/services/navigation';
import ROUTE_IDS from '$src/generated/routeIds';
import { toggleFullScreen } from '$src/lib/services/fullscreen';

export const openChat = () => {
    spineBus.publish('support', { kind: 'open' });
};

export const exitGame = () => navigate(ROUTE_IDS.HOME);

export const toggleGameFullScreen = (gameElement?: HTMLElement) => toggleFullScreen(gameElement);
